import {colors} from "@c10h/colors";
import {useTranslation} from "@i18n/client";
import React from "react";
import {LightLeverJobPostingResponse} from "src/_services/types";
import {careersUrl} from "src/components/_common/_constants";

import {Btn} from "../V5Comp";
import JobGroupCard from "./JobGroupCard";
import SectionHeader from "./SectionHeader";

type Props = {
  jobs: LightLeverJobPostingResponse[];
};

const colorImageRotation = [
  {
    backgroundColor: colors.lightGreen,
    color: colors.darkerGreen,
    backgroundImage: "pattern-0",
  },
  {
    backgroundColor: colors.lightBlue,
    color: colors.darkerBlue,
    backgroundImage: "pattern-1",
  },
  {
    backgroundColor: colors.lightYellow,
    color: colors.darkerYellow,
    backgroundImage: "pattern-2",
  },
  {
    backgroundColor: colors.lightRed,
    color: colors.darkerRed,
    backgroundImage: "pattern-3",
  },
  {
    backgroundColor: colors.lightPurple,
    color: colors.darkerPurple,
    backgroundImage: "pattern-4",
  },
  {
    backgroundColor: colors.lightMint,
    color: colors.darkerMint,
    backgroundImage: "pattern-5",
  },
];

const getColorOption = (i: number) =>
  Object.assign(
    colorImageRotation[i % colorImageRotation.length],
    i % 6 === 0 && !(i % 12 === 0) ? {backgroundImage: "pattern-6"} : {},
  );

const Careers: React.FC<Props> = ({jobs}) => {
  const i18n = useTranslation();

  const jobsByDepartment = jobs.groupBy(job => job.categories.department);
  const jobsByDepartmentArray = jobsByDepartment.getKeys().map(key => ({
    name: key,
    jobs: jobsByDepartment[key],
  }));

  const strings = {
    tag: i18n.t("Join Our Team"),
    header: i18n.t("We're hiring for {{count}} roles", {count: jobs.length}),
    p1: i18n.t(
      "We hire people who genuinely care. In doing so, we’ve built a diverse and passionate team of healthcare experts working to improve how patients and providers experience healthcare.",
    ),
    p2: i18n.t(
      "Bring your talents to Carbon Health and change the future of healthcare for the better, together.",
    ),
  };

  return (
    <div id="careers" className="ph8 ph5-xs pv24 pv16-sm">
      <div className="maxw80 ma">
        <div className="df fdc-md jcsb jcfs-md pb18 pb4-md maxw72">
          <div className="df fdc jcsb">
            <SectionHeader className="fx mr4 mb4" tag={strings.tag} header={strings.header} />
            <div className="minh14 minh0-md">
              <Btn
                fontSize={0.75}
                href={careersUrl}
                className="event-fj1Dgn zIndex3 mb3 focus-bsDarkBlue3"
              >
                {i18n.t("View All Open Positions")}
                <span className="cIcon-arrow-45deg fs8-f ml2" aria-hidden />
              </Btn>
            </div>
          </div>
          <div className="fx2 fs20 mb7-xs mt2 fs18-sm maxw35">
            <p className="font-cm mb6">{strings.p1}</p>
            <p className="font-csb">{strings.p2}</p>
          </div>
        </div>
        <div className="df fw">
          {jobsByDepartmentArray.map((dept, i) => (
            <JobGroupCard
              zIndex={jobsByDepartmentArray.length - i}
              key={dept.name}
              name={dept.name}
              jobs={dept.jobs}
              {...getColorOption(i)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Careers;
